import { render } from "./student-ticket-modal.vue?vue&type=template&id=760e887c"
import script from "./student-ticket-modal.vue?vue&type=script&lang=js"
export * from "./student-ticket-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__